var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 382,
    height: 381,
    viewBox: "0 0 382 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook_",
    "data-name": "Facebook ",
    transform: "translate(0.099)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16750",
    "data-name": "Ellipse 16750",
    cx: 191,
    cy: 190.5,
    rx: 191,
    ry: 190.5,
    transform: "translate(-0.099)",
    fill: "#65cf72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269859",
    "data-name": "Group 269859",
    transform: "translate(74.792 77.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497481",
    "data-name": "Path 497481",
    d: "M6,179.744l15.938-36.706A86.92,86.92,0,1,1,54.78,171.05L6,179.744",
    transform: "translate(22.978 23.103)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497482",
    "data-name": "Path 497482",
    d: "M18,31.489a4.83,4.83,0,1,0,9.659,0V21.83a4.83,4.83,0,1,0-9.659,0v9.659a48.314,48.314,0,0,0,48.3,48.3h9.659a4.83,4.83,0,0,0,0-9.659H66.3a4.83,4.83,0,1,0,0,9.659",
    transform: "translate(68.934 65.105)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497483",
    "data-name": "Path 497483",
    d: "M0,0H231.825V231.825H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.fcd928d421f3c273cfffa36551bb4034.svg";
export { ForwardRef as ReactComponent };